var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('body',{staticStyle:{"text-align":"center","padding-top":"100px"}},[_c('img',{attrs:{"src":require("../public/404.jpg")}})])])}]

export { render, staticRenderFns }